<template>
  <v-app id="app">
    <v-app-bar app v-if="$route.name !== 'Login'">
      <div class="d-flex align-center">
        <v-btn to="/" text class="link">
          <span class="mr-2">GODCS</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <v-btn to="/" text class="link">
        <span class="mr-2">PROJECTS</span>
      </v-btn>

      <v-btn to="/clusters" text class="link">
        <span class="mr-2">CLUSTERS</span>
      </v-btn>

      <v-btn to="/users" text class="link">
        <span class="mr-2">USERS</span>
      </v-btn>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="changePassword">
            <v-list-item-title>Change password</v-list-item-title>
          </v-list-item>
          <v-list-item @click="signOut">
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <div v-if="showLoading" class="spin-bar">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-container fill-height fluid>
        <router-view></router-view>
        <change-password :dialog.sync="changePasswordDialog"></change-password>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ChangePassword from "src/components/userManagement/ChangePassword";

export default {
  components: { ChangePassword },
  data() {
    return {
      changePasswordDialog: false,
    };
  },
  computed: {
    showLoading() {
      return this.$store.state.showLoading;
    },
  },
  methods: {
    signOut() {
      localStorage.removeItem("authen-token");
      this.$router.push({ name: "Login" });
    },
    changePassword() {
      this.changePasswordDialog = true;
    },
  },
};
</script>

<style scoped>
.link:before {
  background-color: transparent;
}

.spin-bar {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
